export default {
  methods: {
    displaySuccessMsg (action) {
      const message = this.$i18n.t('is_successful', {
        operation: this.$i18n.t(action)
      })
      this.$message({
        message,
        type: 'success'
      })
    }
  }
}
